import React from "react";
import SolidarioCheckbox from "./SolidarioCheckbox";

const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("es-EC", { day: "2-digit", month: "2-digit", year: "numeric" });
};

// Fila de la tabla de CarteraBancoSolidario.js — markup y clases tomadas
// directamente del mockup de Stitch (tr resaltada + shadow-md cuando está
// seleccionada, checkbox en el color de marca de Banco Solidario #01BEDE).
export default function CarteraTableRow({ data, index, checked, onToggle, onQuitarLote, quitando }) {
  const tieneLote = Number(data.lote) > 0;
  const confirmado = data.confirmado === true;

  return (
    <tr
      onClick={() => onToggle(data.idCre_SolicitudWeb)}
      className={`cursor-pointer transition-colors ${checked ? "bg-[#01BEDE]/20 shadow-md" : "hover:bg-gray-50"}`}
    >
      <td className="px-4 py-4 whitespace-nowrap" onClick={(e) => e.stopPropagation()}>
        <SolidarioCheckbox checked={checked} onChange={() => onToggle(data.idCre_SolicitudWeb)} />
      </td>
      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-700 font-medium">{data.lote ?? 0}</td>
      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600">{data.NumeroSolicitud}</td>
      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600">{formatDateTime(data.Fecha)}</td>
      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600">{data.Cedula}</td>
      <td className={`px-4 py-4 whitespace-nowrap text-sm text-gray-700 ${checked ? "font-bold" : "font-medium"}`}>
        {data.cliente || "-"}
      </td>
      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600 font-mono">{data.numeroOperacion || "-"}</td>
      <td className="px-4 py-4 whitespace-nowrap" onClick={(e) => e.stopPropagation()}>
        {tieneLote && !confirmado && (
          <button
            type="button"
            onClick={() => onQuitarLote(data.idCre_SolicitudWeb)}
            disabled={quitando}
            className="text-xs font-semibold text-red-500 border border-red-300 rounded-md px-2 py-1 hover:bg-red-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {quitando ? "Quitando..." : "Quitar"}
          </button>
        )}
        {confirmado && (
          <span className="text-xs font-semibold text-emerald-700 border border-emerald-300 bg-emerald-50 rounded-md px-2 py-1">
            Confirmado
          </span>
        )}
      </td>
    </tr>
  );
}
